<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="26.75" height="16.854" viewBox="0 0 26.75 16.854">
    <g transform="translate(-1103.126 -615.969)">
      <g>
        <path
          d="M1123.319,632.823h-20.193l.032-.611a65.434,65.434,0,0,1,1.282-9.916l.581.034.222-.165a4.672,4.672,0,0,0,1.084.969c.674.507,2.026-.343,2.736-.909l-1.005-3.1.94.435a46.607,46.607,0,0,1,5.335,2.91,18.393,18.393,0,0,0,4.4,1.787,14.121,14.121,0,0,1,3.774,1.546c1.965,1.436.95,6.386.906,6.6Zm-19.252-1.144h18.571c.236-1.408.457-4.128-.572-4.876a13.918,13.918,0,0,0-3.545-1.431,18.821,18.821,0,0,1-4.583-1.874,46.586,46.586,0,0,0-4.294-2.4l.505,1.556-.292.265c-.26.229-2.567,2.274-3.975,1.211-.33-.247-.584-.457-.78-.634A63.812,63.812,0,0,0,1104.067,631.679Z"
        />
        <rect
          width="19.583"
          height="1.144"
          transform="translate(1103.787 628.874)"
        />
        <rect
          width="3.155"
          height="1.142"
          transform="translate(1111.444 624.789) rotate(-60.477)"
        />
        <rect
          width="2.841"
          height="1.144"
          transform="matrix(0.512, -0.859, 0.859, 0.512, 1113.24, 625.617)"
        />
      </g>
      <path
        d="M1128.91,630.159h-4.084a.5.5,0,0,1,0-1h3.693a13.573,13.573,0,0,0,.349-3.1c.032-2.492-1.66-3.033-2.935-3.224a34.544,34.544,0,0,1-6.361-2.48q-2.006-1.108-3.893-2.413l.573,1.306a.5.5,0,0,1-.175.613l-1.308.9a.5.5,0,1,1-.567-.825l.968-.666-1.143-2.6a.5.5,0,0,1,.759-.6,45.276,45.276,0,0,0,5.255,3.407,33.711,33.711,0,0,0,6.1,2.386c3.108.462,3.747,2.542,3.725,4.2a14.525,14.525,0,0,1-.474,3.72A.5.5,0,0,1,1128.91,630.159Z"
      />
      <path
        d="M1129.376,626.879h-4.522a.5.5,0,0,1,0-1h4.522a.5.5,0,0,1,0,1Z"
      />
      <path
        d="M1118.059,622.324a.5.5,0,0,1-.439-.74l1.068-1.947a.5.5,0,1,1,.876.48l-1.067,1.947A.5.5,0,0,1,1118.059,622.324Z"
      />
      <path
        d="M1119.847,623.231a.5.5,0,0,1-.419-.773l1.339-2.053a.5.5,0,0,1,.837.547l-1.338,2.053A.5.5,0,0,1,1119.847,623.231Z"
      />
    </g>
  </svg>
</template>
